module.exports = __webpack_public_path__ + "img/table-addra-icon.6acf3b8a.svg";